import React from 'react';
import { Store } from '../../store';

import { toggleDetailAction, toggleFavAction } from '../../actions';
import _ from 'lodash';
import { MDBIcon } from 'mdbreact';
//import { Gauge } from '../Gauge';
import { StarsRating } from '../StarsRating';

import './ProductDetail.scss';
import { Container, Row, Col, Table } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Button from 'react-bootstrap/Button'

export interface ProductCompareProps {
}

const ProductDetail: React.SFC<ProductCompareProps> = (props: ProductCompareProps) => {

  const { state, dispatch }: any = React.useContext(Store);

  const favs = state.favs;
  
  const popover_category_detail = (
    <Popover id="popover-basic">
      {/* <Popover.Title as="p"><strong>Catégorie détaillée</strong></Popover.Title> */}
      <Popover.Title as="p"><strong>Catégorie</strong></Popover.Title>
      <Popover.Content>
        <p className="m-0">Les fonds sont regroupés dans des catégories en fonction de leur style de gestion effectif, et non pas seulement de leur objectif d’investissement déclaré.</p>
        <p className="m-0">Afin de créer des catégories homogènes, Morningstar affecte généralement des catégories aux fonds en fonction des portefeuilles de ceux-ci.</p>
        <p className="m-0">Plusieurs portefeuilles sont pris en compte pour que les styles de gestion réels du fonds soient correctement identifiés.</p>
      </Popover.Content>
    </Popover>
  );

  const popover_notation = (
    <Popover id="popover-basic">
      <Popover.Title as="p"><strong>La notation Morningstar</strong></Popover.Title>
      <Popover.Content>
        <p className="m-0">Elle s’applique aux fonds disposant d’au moins 3 ans d’historique. Elle tient compte des frais de souscription, du rendement sans risque et de la volatilité du fonds. Les fonds sont classés ensuite par ordre décroissant :</p>
        <ul className="m-0">
          <li>les 10 premiers pourcents reçoivent 5 étoiles ;</li>
          <li>les 22,5% suivants 4 étoiles,</li>
          <li>les 35% suivants 3 étoiles ;</li>
          <li>les 22,5% suivants 2 étoiles ;</li>
          <li>les 10% derniers reçoivent 1 étoile.</li>
        </ul>
      </Popover.Content>
    </Popover>
  );

  const popover_levelrisque = (
    <Popover id="popover-basic">
      <Popover.Title as="p"><strong>Niveau de risque</strong></Popover.Title>
      <Popover.Content>
        <p className="m-0"></p>
      </Popover.Content>
    </Popover>
  );

  const popover_perf = (
    <Popover id="popover-basic">
      <Popover.Title as="p"><strong>Performance</strong></Popover.Title>
      <Popover.Content>
        <p className="m-0">La performance est la mesure de l’évolution (positive ou négative) d’un investissement sur une période donnée. Dans le cas de fonds ayant des stratégies d’investissement similaires, les investisseurs peuvent comparer les performances de chacun.</p>
      </Popover.Content>
    </Popover>
  );

  const popover_frais = (
    <Popover id="popover-basic">
      <Popover.Title as="p"><strong>Frais</strong></Popover.Title>
      <Popover.Content>
        <p className="m-0">Une sélection qualitative de 50 fonds vous est proposée sans droits d'entrée. Les clients BforBank disposent également d'un univers de 2000 fonds sans droits d'entrée disponible dans leur espace client.</p>
      </Popover.Content>
    </Popover>
  );

  const formatPourcent = (number: number | undefined, order?: "asc"|"desc") => {
    let pourcentDisplay = `<span class="text-danger">0%</span>`;
    if (number !== undefined) {
      let pourcent: number | string = (number !== null) ? number.toFixed(2) : 0;

      if (Math.sign(pourcent) === (order === "desc" ? 1 : -1)) {
        pourcentDisplay = `<span class="text-danger">${pourcent}%</span>`;
      } else {
        pourcentDisplay = `<span class="text-primary">${pourcent}%</span>`;
      }
    }
    return pourcentDisplay;
  }

  function onClickReturn() {
    toggleDetailAction(false, null, dispatch);
  }

  return (
    <Container className={`dataData container-fluid ${!state.dataCompare && state.detail_page.show ? 'd-block' : 'd-none'}`}>
      <Row className="row-listing">
        <Col xs={12}>
          {state.detail_page.content && state.detail_page.content._source && (
          <Container className="mt-3">
            
              <Row>
                <Col>
                  <div className="mb-0 border-title">
                    <h1>{state.detail_page.content._source.name}</h1>
                    <div>
                      <Button
                        type="submit"
                        variant="outline-danger"
                        className="ml-4 mb-1"
                        onClick={() => onClickReturn()}
                      >
                        Retour
                      </Button>
                      {favs.length < 3 &&
                        !_.find(favs, [
                          "_id",
                          state.detail_page.content._id
                        ]) && (
                          <Button
                            type="submit"
                            variant="outline-primary"
                            className="ml-4 mb-1"
                            onClick={() =>
                              toggleFavAction(
                                state.detail_page.content,
                                state,
                                dispatch
                              )
                            }
                          >
                            Ajouter au comparateur
                          </Button>
                        )}
                      {_.find(favs, [
                        "_id",
                        state.detail_page.content._id
                      ]) && (
                        <Button
                          type="submit"
                          variant="outline-warning"
                          className="ml-4 mb-1"
                          onClick={() =>
                            toggleFavAction(
                              state.detail_page.content,
                              state,
                              dispatch
                            )
                          }
                        >
                          Supprimer du comparateur
                        </Button>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
            <Row>
              <Col>
                <h2 className="compare__title text-uppercase px-2">
                  Caractéristiques
                </h2>
                <Table
                  striped
                  hover
                  className="table-listing"
                  responsive="md"
                >
                  <tbody>
                    <tr>
                      <th className="w-30">Code ISIN</th>
                      <td className="flex-fill w-25">
                        <div>{state.detail_page.content._source.isin}</div>
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Société de gestion</th>
                      <td className="flex-fill w-25">
                        <div>
                          {state.detail_page.content._source.advisor}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Date de création du Fonds</th>
                      <td className="flex-fill w-25">
                        <div>
                          {new Intl.DateTimeFormat("fr-FR", {
                            year: "numeric",
                            month: "long",
                            day: "2-digit"
                          }).format(
                            new Date(
                              state.detail_page.content._source.creation_date
                            )
                          )}
                        </div>
                      </td>
                    </tr>
                    {/* <tr>
                      <th className="w-30">Catégorie générale</th>
                      <td className="flex-fill w-25">
                        <div>
                          {
                            state.detail_page.content._source
                              .general_category
                          }
                        </div>
                      </td>
                    </tr> */}
                    <tr>
                      <th className="w-30">
                        <div className="d-flex justify-content-between">
                          {/* <p className="my-0">Catégorie Détaillée</p> */}
                            <p className="my-0">Catégorie</p>
                          <OverlayTrigger
                            trigger="click"
                            placement="top"
                            rootClose={true}
                            overlay={popover_category_detail}
                          >
                            <Button
                              className="compare__tooltip p-0"
                              variant="secondary"
                            >
                              i
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </th>
                      <td className="flex-fill w-25">
                        <div>
                          {
                            state.detail_page.content._source
                              .detailed_category
                          }
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Zone géographique</th>
                      <td className="flex-fill w-25">
                        <div>
                          {state.detail_page.content._source.geo_category}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">
                        <div className="d-flex justify-content-between">
                          <p className="my-0">Notation morning star</p>
                          <OverlayTrigger
                            trigger="click"
                            placement="top"
                            rootClose={true}
                            overlay={popover_notation}
                          >
                            <Button
                              className="compare__tooltip p-0"
                              variant="secondary"
                            >
                              i
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </th>
                      <td className="flex-fill compare w-25">
                        <div>
                          <StarsRating
                            stars={state.detail_page.content._source.rating}
                          ></StarsRating>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Éligibilité PEA</th>
                      <td className="flex-fill w-25">
                        <div>
                          {state.detail_page.content._source.french_pea ===
                          1 ? (
                            <MDBIcon
                              icon="check"
                              className="text-success"
                            />
                          ) : (
                            <MDBIcon icon="times" className="text-danger" />
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            {/* <Row>
    <Col>
      <h2 className="compare__title text-uppercase px-2">
        Indicateurs de risque
      </h2>
      <Table striped hover className="table-listing" responsive="md">
        <tbody>
          <tr>
            <th className="w-30">
              <div className="d-flex justify-content-between">
                <p className="my-0">Niveau de risque</p>
                <OverlayTrigger
                  trigger="click"
                  placement="top"
                  rootClose={true}
                  overlay={popover_levelrisque}
                >
                  <Button
                    className="compare__tooltip p-0"
                    variant="secondary"
                  >
                    i
                  </Button>
                </OverlayTrigger>
              </div>
            </th>
            <td className="flex-fill w-25">
              <div>
                <Gauge gauge={state.detail_page.content._source.srri}></Gauge>
              </div>
            </td>
          </tr>
          <tr>
            <th className="w-30">Date du risque</th>
            <td className="flex-fill w-25">
              <div>
                {new Intl.DateTimeFormat("fr-FR", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit"
                }).format(new Date(state.detail_page.content._source.srri_date))}
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </Col>
  </Row> */}
            <Row>
              <Col>
                <h2 className="compare__title text-uppercase px-2">
                  Performances
                </h2>
                <Table
                  striped
                  hover
                  className="table-listing"
                  responsive="md"
                >
                  <tbody>
                    <tr>
                      <th className="w-30">
                        <div className="d-flex justify-content-between">
                          <p className="my-0">
                            Performances depuis le début de l'année
                          </p>
                          <OverlayTrigger
                            trigger="click"
                            placement="top"
                            rootClose={true}
                            overlay={popover_perf}
                          >
                            <Button
                              className="compare__tooltip p-0"
                              variant="secondary"
                            >
                              i
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .performance_current_year
                            )
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Performances 1 an</th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .performance_end_of_month_1_year
                            )
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Performances 3 ans</th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .performance_end_of_month_3_years
                            )
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Performances 5 ans</th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .performance_end_of_month_5_years
                            )
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Performances 10 ans</th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .performance_end_of_month_10_years
                            )
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row>
              <Col>
                <h2 className="compare__title text-uppercase px-2">
                  Frais
                </h2>
                <Table
                  striped
                  hover
                  className="table-listing"
                  responsive="md"
                >
                  <tbody>
                    <tr>
                      <th className="w-30">
                        <div className="d-flex justify-content-between">
                          <p className="my-0">Frais d'entrée</p>
                          <OverlayTrigger
                            trigger="click"
                            placement="top"
                            rootClose={true}
                            overlay={popover_frais}
                          >
                            <Button
                              className="compare__tooltip p-0"
                              variant="secondary"
                            >
                              i
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .purchase_charge_front_load_fee
                            )
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">
                        Frais d'entrée négociés par BforBank
                      </th>
                      <td className="flex-fill w-25">
                        <div>
                          {state.detail_page.content._source.b4b_negociated_fee ===
                          1 ? (
                            <MDBIcon
                              icon="check"
                              className="text-success"
                            />
                          ) : (
                            <MDBIcon icon="times" className="text-danger" />
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Frais de sortie</th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .purchase_charge_front_redemption_fee
                            )
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th className="w-30">Frais courants</th>
                      <td className="flex-fill w-25">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: formatPourcent(
                              state.detail_page.content._source
                                .management_fee
                            )
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ProductDetail;
